import { render, staticRenderFns } from "./GameGroup.vue?vue&type=template&id=c9f7b7a2&scoped=true"
import script from "./GameGroup.vue?vue&type=script&lang=js"
export * from "./GameGroup.vue?vue&type=script&lang=js"
import style0 from "./GameGroup.vue?vue&type=style&index=0&id=c9f7b7a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f7b7a2",
  null
  
)

export default component.exports